export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h48v48H0z\"/><g fill-rule=\"nonzero\"><path fill=\"#D7D8DE\" d=\"M1 28v6c0 1.1 1.058 2 2.351 2H45c1.1 0 2-.9 2-2v-6H1z\"/><g fill=\"#3F4450\" transform=\"translate(0 3)\"><circle cx=\"24\" cy=\"29\" r=\"1\"/><path d=\"M45 0H3C1.346 0 0 1.346 0 3v28c0 1.654 1.346 3 3 3h17v5h-4v2h16v-2h-4v-5h17c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3zM3 2h42c.551 0 1 .449 1 1v21H2V3c0-.551.449-1 1-1zm23 37h-4v-5h4v5zm19-7H3c-.551 0-1-.449-1-1v-5h44v5c0 .551-.449 1-1 1z\"/></g></g></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48"
  }
};